import React, { useEffect } from 'react';
import {
  commerceCartAddProduct,
  setOperationStatus,
  UI_OPERATION_STATUS_SUCCESS,
} from '@uncinc/react-drupal-core';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';

import './style.scss';


const dateStringGenerator = (date) => {
  return `${date.toLocaleDateString('nl-NL', { weekday: 'long' })} ${date.getDate()} ${date.toLocaleDateString('nl-NL', {
    month: 'long',
  })} ${date.getFullYear()}`;
};


const hourGenerator = (date, dateEnd) => {
  return `${format(date, 'HH:mm')} - ${format(dateEnd, 'HH:mm')}`;
};


const MultiDay = ({ entity }) => {
  const dates = entity.get('field_date');

  return (
    <div className="Training__multidays">
      {dates.map((date, i) => {
        const startDate = new Date(date.get('value', ''));
        const endDate = new Date(date.get('end_value', ''));
        const middleElement = i > 0 && i < dates.size - 1;
        const lastElement = i === dates.size - 1;

        let headerElement = <i className="icon icon-calendar" />;
        if (middleElement) headerElement = <div className="Training__multidays__day__dotted" />;
        if (lastElement) { headerElement = (
          <div className="Training__multidays__day__circle">
            <div className="Training__multidays__day__circle__inner" />
          </div>
        ); }

        return (
          <div key={`${startDate}${endDate}`} className={`Training__multidays__day ${middleElement ? 'middle' : ''}`}>
            <div className="Training__multidays__day__header">
              {headerElement}
              <div className="Training__title">{dateStringGenerator(startDate)}</div>
            </div>
            <div className="Training__metadata__item">
              {!lastElement && <div className="Training__multidays__day__dotted" />}
              <div className="Training__metadata__item__time">
                <i className="icon icon-before icon-time" />
                {hourGenerator(startDate, endDate)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};


const Training = ({ entity }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const date = new Date(entity.getIn(['field_date', 0, 'value']));
  const dateEnd = new Date(entity.getIn(['field_date', 0, 'end_value']));
  const productAddStatus = useSelector((state) => state.getIn(['ui', 'commerce', 'operations', 'cart_product_add', 'status']),
  );
  const location = entity.getIn(['field_location', 0, 'value'], 'Onbekend');
  const title = entity.getIn(['title', 0, 'value'], '');
  const status = entity.getIn(['field_status', 0, 'value'], 'open');
  const participants = parseInt(entity.getIn(['participants'], 0));
  const maxParticipants = parseInt(
    entity.getIn(['field_maximum_participants', 0, 'value'], 0),
  );
  const freeSeats = maxParticipants - participants;

  const singleDay = entity.get('field_date').size === 1;

  const subscribeForEvent = () => {
    const uuid = entity.getIn(['variations', 0, 'target_uuid']);
    const sku = entity.getIn(['variations', 0, 'sku']);
    const price = entity.getIn(['variations', 0, 'price', 'number']);
    dispatch(commerceCartAddProduct(uuid, 1));

    if (window) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        productName: title,
        productPrice: price,
        productQuantity: 1,
        productSku: sku,
        ecommerce: {
          currency: 'EUR',
          value: price,
          items: [
            {
              item_id: sku,
              item_name: title,
              price: price,
              quantity: 1
            }
          ]
        }
      });
    }
  };

  useEffect(() => {
    if (productAddStatus === UI_OPERATION_STATUS_SUCCESS) {
      dispatch(setOperationStatus('commerce', 'cart_product_add', null));
    }
  }, [productAddStatus, history, dispatch]);

  return (
    <Container>
      <div className="Training row">
        <div className="Training__content col-12 col-lg-8" id="main">
          <div className="Training__location">
            <i className="icon icon-before icon-marker" />
            {location}
          </div>
          <div className="Training__metadata">


            {singleDay
              ? (
                <>
                  <div className="Training__multidays__day__header">
                    <i className="icon icon-calendar" />
                    <h4 className="Training__title">{dateStringGenerator(date)}</h4>
                  </div>
                  <div className="Training__metadata__item">
                    <div className="Training__metadata__item__time">
                      <i className="icon icon-before icon-time" />
                      {hourGenerator(date, dateEnd)}
                    </div>
                  </div>
                </>
              )
              : <MultiDay entity={entity} />}

          </div>
        </div>
        <div className="Training__actions col-lg-4">
          {maxParticipants !== 0 && (freeSeats === 0 || status === 'closed' || status === 'cancelled' || status === 'full') ? (
            <Button primary={false} className="Button--primary" disabled>Gesloten</Button>
          ) : (
            <Button
              primary={false}
              className="Button--primary icon-after icon-arrow-right icon-variant-2"
              onClick={() => subscribeForEvent()}
            >
              Inschrijven
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

export default Training;
